import { createSlice } from '@reduxjs/toolkit';
import { bffRequestV1 } from '../../app/bffClient';
import { postMessage } from 'bff-api/mitt-malarenergi/v1';

const distanceHeatingContractSlice = createSlice({
  name: 'fjv-contract',
  initialState: {
    contractHasBeenSent: false,
  },
  reducers: {
    setContractHasBeenSent: (state) => {
      state.contractHasBeenSent = true;
    },
  },
});

const { setContractHasBeenSent } = distanceHeatingContractSlice.actions;

export const postContractType = (body) => (dispatch) => {
  return bffRequestV1((client) =>
    postMessage({
      client,
      body,
      throwOnError: true,
    }),
  ).then(() => dispatch(setContractHasBeenSent()));
};

export default distanceHeatingContractSlice.reducer;
